import React from 'react';
import WizardContainer from '../../components/Wizard/WizardContainer';
import { ApplicationStatus } from '../../types/wizard';
import { usePageTracking, useWizardStepTracking } from '../../hooks/useAnalytics';

interface InterviewCompleteProps {
  applicationStatus: ApplicationStatus;
}

const InterviewComplete: React.FC<InterviewCompleteProps> = ({ applicationStatus }) => {
  usePageTracking('Interview Complete');
  useWizardStepTracking('interview-complete', 6, 7);

  return (
    <WizardContainer
      currentStepId="interview-complete"
      applicationStatus={applicationStatus}
    >
      <div className="max-w-2xl mx-auto">
        <div className="card p-8 text-center">
          <div className="text-6xl mb-6">✅</div>

          <h1 className="text-3xl font-bold text-charcoal mb-4">
            Interview Complete!
          </h1>

          <p className="text-lg text-gray-600 mb-6">
            Thank you for taking the time to interview with us!
          </p>

          <div className="bg-logo-green/10 border border-logo-green rounded-lg p-6 mb-6">
            <div className="flex items-start gap-3 text-left">
              <div className="text-2xl mt-1">🎯</div>
              <div>
                <p className="font-semibold text-charcoal mb-2">
                  What's next?
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• We're reviewing your interview and making our decision</li>
                  <li>• If approved, we'll initiate your background check</li>
                  <li>• You'll receive an email update within 1-2 business days</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-6">
            <p className="text-sm text-gray-600">
              <strong>Thank you for your patience!</strong> We'll be in touch soon with next steps.
            </p>
          </div>
        </div>
      </div>
    </WizardContainer>
  );
};

export default InterviewComplete;
